import { render } from "./ReviewEvent.vue?vue&type=template&id=4e35c1e9&scoped=true"
import script from "./ReviewEvent.vue?vue&type=script&lang=js"
export * from "./ReviewEvent.vue?vue&type=script&lang=js"

import "./ReviewEvent.vue?vue&type=style&index=0&id=4e35c1e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e35c1e9"]])

export default __exports__